import { useState, useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { AuthContext } from '../../context/UserContext';

import { SpinnerForm } from '../../components/spinner';

import MessageModal from '../message-modal';

import DetailInfoPartToList from '../detail-info-part-to-list';

import { getListInfo, createNewList, addPartToList } from '../../services';

import { getLangSite } from '../../ultils';

import './AddToListForm.scss';
import { callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import { useRecoilState } from 'recoil';

interface ModalProps {
  isFormOpen: boolean;
  setIsFormOpen: (isFormOpen: boolean) => void;
  selectedData: any;
  currentUrlToRedirect: string;
  isReverse: boolean;
}

const AddToListForm: React.FC<ModalProps> = ({
  isFormOpen,
  setIsFormOpen,
  selectedData,
  currentUrlToRedirect,
  isReverse
}) => {
  const { t } = useTranslation();

  const [utagData] = useRecoilState(utagObjectAtom);

  const [errorsState, setErrorsState] = useState<any>({});

  const [isFetching, setIsFetching] = useState<boolean>(false);

  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const [linkToList, setLinkToList] = useState<string>('');

  const { userData } = useContext(AuthContext);

  const [inputObject, setInputObject] = useState<any>({});

  const [listDetails, setListDetails] = useState<any>([{}]);

  useEffect(() => {
    const getListObject = async () => {
      // display spinner
      setIsFetching(true);
      const response = await getListInfo(userData.CustomerId);
      setListDetails(response);

      // If we have existing list, then make existing radio to true, otherwise ...
      if (response.length > 0) {
        setInputObject({
          radioListOption: 'isExisted',
          newListName: '',
          existedListId: response[0].id,
          existedListName: response[0].listName
        });
      } else {
        setInputObject({
          radioListOption: 'isNewList',
          newListName: '',
          existedListId: ''
        });
      }
      // hide spinner
      setIsFetching(false);
    };
    // get new list when the addtolist form is open
    if (isFormOpen) {
      getListObject();
    }
  }, [isFormOpen, userData.CustomerId]);

  const onHandleChange = (e: any) => {
    const data = { ...inputObject };

    data[e.target.name] = e.target.value;

    if (e.target.selectedOptions)
      data['existedListName'] = e.target.selectedOptions[0].text;

    setInputObject(data);
  };

  const onHandleSubmit = async (e: any) => {
    e.preventDefault();

    const bodyRequest: { partId: number }[] = [];

    const errors: any = {};

    // ! Get lang from URL
    const langSiteObj = getLangSite('en');
    const lang = langSiteObj.lang;

    // ! PARAM TO CALL API
    selectedData.forEach((element: any) => {
      bodyRequest.push({
        partId: element.productId
      });
    });

    // ? Handle For 1 action :  Add Parts Starts
    if (inputObject.radioListOption === 'isExisted') {
      // ! Validation has list name
      if (inputObject.existedListId) {
        errors.isExistedListId = false;

        // ! ACTION CALL API ADD PART TO LIST
        setIsFetching(true);

        const resultAddPartsToList = await addPartToList(
          userData.CustomerId,
          inputObject.existedListId,
          bodyRequest
        );

        const urlRedirectToCreatedList = `${window.location.origin}/${lang}/mylists/list/${inputObject.existedListId}`;

        setIsFetching(false);

        if (resultAddPartsToList && resultAddPartsToList.length > 0) {
          // ADD SUCCESS

          setIsSuccess(true);

          setLinkToList(urlRedirectToCreatedList);
          callGTMAnalytics(utagData, 'Add To List', selectedData);
        }
      } else {
        errors.isExistedListId = true;
      }
    }
    // ? Handle For 1 action :  Add Parts Starts Ends

    // ? Handle For 2 action : Add New List and Add Parts Starts
    if (inputObject.radioListOption === 'isNewList') {
      // ! Validation has list name
      if (inputObject.newListName) {
        errors.isnewListName = false;

        // ! ACTION CALL API CREATE NEW LIST
        setIsFetching(true);

        const listId = await createNewList(
          userData.CustomerId,
          inputObject.newListName
        );

        if (
          listId.detail !== 'The list name already exists under the root ID'
        ) {
          const urlRedirectToCreatedList = `${window.location.origin}/${lang}/mylists/list/${listId}`;

          // ! ACTION CALL API ADD PART TO LIST

          const resultAddPartsToList = await addPartToList(
            userData.CustomerId,
            listId,
            bodyRequest
          );

          setIsFetching(false);

          if (resultAddPartsToList && resultAddPartsToList.length > 0) {
            // ADD SUCCESS
            setIsSuccess(true);

            setLinkToList(urlRedirectToCreatedList);
            callGTMAnalytics(utagData, 'Add To List', selectedData);
          }

          errors.newListExisted = '';
        } else {
          setIsFetching(false);

          errors.newListExisted = t('xref-the-list-name-already-exists');
        }
      } else {
        errors.isnewListName = true;
      }
    }
    // ? Handle For 2 action : Add New List and Add Parts Ends

    setErrorsState(errors);
  };

  const onClose = () => {
    setIsFormOpen(!isFormOpen);
    setErrorsState({});
    setIsSuccess(false);
  };

  return isFormOpen ? (
    <div className="add-to-list-modal">
      <div className="dialog-add-to-list-modal">
        {userData.IsLoggedIn && userData.CustomerId !== 0 ? (
          //  Avaiable when user logs in
          <form onSubmit={onHandleSubmit}>
            <div className="modal-box">
              <div className="modal-header-form-custom">
                <div className="modal-title-area">
                  <h3 className="modal-title-form-custom">
                    {' '}
                    {t('xref-add-to-list')}{' '}
                  </h3>
                </div>
                <button
                  type="button"
                  className={
                    'close-button-form-area ' +
                    (isReverse ? 'left-0' : 'right-0')
                  }
                  data-dismiss="modal"
                  onClick={onClose}
                >
                  ×
                </button>
              </div>

              {isFetching ? (
                <SpinnerForm />
              ) : isSuccess ? (
                <DetailInfoPartToList
                  selectedData={selectedData}
                  listName={
                    inputObject.radioListOption === 'isExisted'
                      ? inputObject.existedListName
                      : inputObject.newListName
                  }
                />
              ) : (
                <div className="modal-form-body">
                  {/* // ? Existing List Starts */}
                  <div className="dk-radio-group">
                    <input
                      type="radio"
                      className="dk-radio"
                      id="isExisted"
                      name="radioListOption"
                      value="isExisted"
                      checked={inputObject.radioListOption === 'isExisted'}
                      disabled={listDetails.length === 0}
                      data-testid="isExistedRadio"
                      onChange={onHandleChange}
                    />
                    <label
                      htmlFor="isExisted"
                      className="{listDetails.length === 0 ? 'diabled-option' : ''} dk-radio-label"
                    >
                      {' '}
                      {t('xref-existing-list')}{' '}
                    </label>
                    <div className="virtual-checkbox"></div>
                  </div>

                  <select
                    id="inputState"
                    className={`${
                      !errorsState.isExistedListId && 'my-2'
                    } dk-input`}
                    name="existedListId"
                    value={inputObject.existedListId}
                    disabled={listDetails.length === 0}
                    data-testid="listInfo"
                    onChange={onHandleChange}
                  >
                    {listDetails && listDetails.length > 0 && (
                      <option value="" disabled>
                        {t('xref-select-an-option')}
                      </option>
                    )}

                    {listDetails &&
                      listDetails.length > 0 &&
                      listDetails.map((listDetail: any) => (
                        <option
                          key={listDetail.id}
                          data-testid={listDetail.id}
                          value={listDetail.id}
                        >
                          {listDetail.listName}
                        </option>
                      ))}
                  </select>

                  {errorsState.isExistedListId && (
                    <div className="mb-2 mt-1 message-error ">
                      <strong className="warning-icon">!</strong>{' '}
                      {t('xref-a-list-name-is-required')}
                    </div>
                  )}

                  {/* // ? Existing List Ends */}

                  {/* // ? New List Starts */}
                  <div className="dk-radio-group">
                    <input
                      type="radio"
                      className="dk-radio"
                      id="isNewList"
                      name="radioListOption"
                      value="isNewList"
                      checked={inputObject.radioListOption === 'isNewList'}
                      data-testid="isNewListRadio"
                      onChange={onHandleChange}
                    />
                    <label htmlFor="isNewList" className="dk-radio-label">
                      {t('xref-new-list')}{' '}
                    </label>
                    <div className="virtual-checkbox"></div>
                  </div>

                  <input
                    type="text"
                    className={`${
                      (!errorsState.isnewListName ||
                        !errorsState.newListExisted) &&
                      'my-2'
                    } dk-input`}
                    placeholder="List Name"
                    name="newListName"
                    data-testid="newListNameInput"
                    value={inputObject.newListName}
                    onChange={onHandleChange}
                  />

                  {errorsState.isnewListName && (
                    <div className="mb-2 mt-1 message-error ">
                      <strong className="warning-icon">!</strong>{' '}
                      {t('xref-a-list-name-is-required')}
                    </div>
                  )}
                  {errorsState.newListExisted && (
                    <div className="mb-2 mt-1 message-error ">
                      <strong className="warning-icon">!</strong>{' '}
                      {t('xref-the-list-name-already-exists')}
                    </div>
                  )}

                  {/* // ? New List Ends */}
                </div>
              )}

              <div className="action-button-container">
                <div className="add-to-list-btn-area ">
                  {isSuccess ? (
                    <a
                      href={linkToList}
                      rel="noreferrer"
                      className="dk-btn__primary view-list-link"
                    >
                      {t('xref-view-list')}
                    </a>
                  ) : (
                    <button
                      type="submit"
                      className="dk-btn__primary"
                      data-dismiss="modal"
                      data-testid="addToListBtn"
                    >
                      {t('xref-add-to-list')}
                    </button>
                  )}
                </div>

                <div className="close-btn-area justify-content-end">
                  <button
                    type="button"
                    className="dk-btn__secondary"
                    data-dismiss="modal"
                    data-testid="close-test-btn"
                    onClick={onClose}
                  >
                    {isSuccess ? t('xref-close') : t('xref-cancel')}
                  </button>
                </div>
              </div>
            </div>
          </form>
        ) : (
          // Message modal when user not log in
          <MessageModal
            isFormOpen={isFormOpen}
            setIsFormOpen={setIsFormOpen}
            currentUrlToRedirect={currentUrlToRedirect}
            isReverse={isReverse}
          />
        )}
      </div>
    </div>
  ) : null;
};

export default AddToListForm;
